import { Play } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { API } from "@/lib/api";

export const UgcVideos = ({ videos = [] }) => (
  <section id="videos" className="py-24 md:py-32 bg-white overflow-hidden" data-testid="ugc-videos-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="See Them In Action"
        title={<>Real routines, <span className="italic gold-text">real moments</span></>}
        copy="Short clips from our community — morning routines, getting-ready moments and five minutes of calm."
      />
    </div>
    <Reveal delay={0.1}>
      <div
        className="mt-14 flex gap-5 overflow-x-auto hide-scrollbar snap-x snap-mandatory px-5 sm:px-8 pb-4 max-w-7xl mx-auto"
        data-testid="ugc-video-carousel"
      >
        {videos.map((v, i) => (
          <div
            key={v.id}
            data-testid={`ugc-video-${i}`}
            className="group relative shrink-0 w-[220px] sm:w-[250px] aspect-[9/16] snap-start overflow-hidden rounded-3xl border border-champagne/70 bg-gradient-to-b from-champagne/80 via-cream to-gold-light/40 shadow-[0_16px_40px_rgb(0,0,0,0.06)]"
          >
            {v.storage_path ? (
              <video
                src={`${API}/files/${v.storage_path}`}
                poster={v.poster_path ? `${API}/files/${v.poster_path}` : undefined}
                controls
                playsInline
                preload="metadata"
                className="absolute inset-0 w-full h-full object-cover"
                data-testid={`ugc-video-player-${i}`}
              />
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
                <span className="w-14 h-14 rounded-full bg-white/80 backdrop-blur flex items-center justify-center shadow-[0_8px_24px_rgb(201,162,39,0.18)] transition-transform duration-500 group-hover:scale-110">
                  <Play size={20} className="text-gold-deep ml-0.5" strokeWidth={1.5} fill="currentColor" />
                </span>
                <span className="text-[11px] tracking-[0.2em] uppercase text-[#8C8C8C]">Customer video · coming soon</span>
              </div>
            )}
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-ink/60 to-transparent p-4 pt-10 pointer-events-none">
              <p className="text-white text-sm font-medium" data-testid={`ugc-video-caption-${i}`}>{v.caption}</p>
            </div>
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);
